export const asyncTryCatch = <TResult>(promise: Promise<TResult>): Promise<{ isError:boolean; value: TResult | Error }> => {
  return promise.then((result) => {
    return { isError: false, value: result };
  }).catch((e) => {
    return { isError: true, value: new Error(e.message) };
  });
};